export { default } from './svg/eye.svg';
